;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('markImage', markImage)

  function markImage () {
    return {
      restrict: 'E',
      scope: {
        imageUrl: '=',
        allowMarkup: '<',
        fixedPins: '=',
        selectedPin: '=',
        onMark: '&'
      },
      templateUrl: '/core/directives/mark-image/mark-image-directive.html?$$REVISION$$',
      controller: 'MarkImageController'
    }
  }
})()
